/**
 * Do not edit directly
 */

export default "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PC9kZWZzPjxnID48cGF0aCBkPSJNMTIsMUExMC42OSwxMC42OSwwLDEsMSwxLjMxLDExLjY5LDEwLjcsMTAuNywwLDAsMSwxMiwxWm0wLDEuNWE5LjE5LDkuMTksMCwxLDAsOS4xOSw5LjE5QTkuMiw5LjIsMCwwLDAsMTIsMi41Wm0uNzUsMTMuODZ2MS4wOWgtMS41VjE2LjM2Wm0wLTEwLjU2VjE1aC0xLjVWNS44WiIvPjwvZz48L3N2Zz4=";